import { render, staticRenderFns } from "./PT010GrobalMenuParts.vue?vue&type=template&id=0f75a3ec&"
import script from "./PT010GrobalMenuParts.vue?vue&type=script&lang=js&"
export * from "./PT010GrobalMenuParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports